<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Perfiles</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>C-00</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Búsqueda de perfiles
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre del perfil"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtenerPerfiles"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right" v-if="$localStorageService.can('BO_06_alta_perfiles')">
              <b-button v-b-tooltip.hover title="Crear perfil" variant="outline-success"
                        @click="agregar()">Crear perfil
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
              <template v-slot:cell(fechaModificacion)="row">
                                {{ row.item.fechaModificacion | formatoFechaCorta }}
                            </template>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button v-if="$localStorageService.can('BO_06_modif_perfiles')"
                          title="Modificar plan"
                          size="sm"
                          @click="modificar(row.item)"
                          variant="outline-warning"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button v-if="!row.item.registroActivo && $localStorageService.can('BO_06_activar_perfil')"
                          title="Activar perfil"
                          variant="outline-danger"
                          size="sm"
                          @click="eliminar(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-else-if="$localStorageService.can('BO_06_baja_perfil')"
                          title="Eliminar perfil"
                          variant="outline-danger"
                          size="sm"
                          @click="eliminar(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>

              </b-button-group>

            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>


      </b-row>

    </b-container>


    <b-modal
        v-model="show"
        :title="tituloModal"
        no-close-on-backdrop
        size="xl"
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-col cols="12">
                <b-form-group align="left">
                  <label for="nombrePerfil">Nombre
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="nombrePerfil" name="nombreMenu" placeholder="Nombre del perfil"
                                  v-model="$v.perfil.nombrePerfil.$model"
                                  :state="validateState('nombrePerfil')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" v-if="!nuevo">
                <b-form-group>
                  <label for="permisos">Permisos </label>
                  <input type="text" placeholder="Buscar permiso" v-model="nombrePermiso">
                </b-form-group>
                <b-row style="height: 400px; overflow-y: auto">
                    <template v-for="perm in permisos" >
                      <b-col cols="2" v-bind:key="perm.value" v-if="perm.permiso.toUpperCase().includes(nombrePermiso.toUpperCase())">
                          <b-form-checkbox style="text-align: left"
                              switch
                              :disabled="perm.disabled"
                              v-model="perm.activo"
                             @click.native.prevent="activarDesactivarPermiso(perm)">
                            {{perm.permiso}}
                            <b-spinner small v-if="perm.disabled"></b-spinner>
                          </b-form-checkbox>
                      </b-col>
                    </template>
                </b-row>
              </b-col>

            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import _ from 'lodash';

export default {
  name: "PerfilesIndex",
  components: {
    Header
  },
  mixins: [validationMixin],
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      nuevo: false,
      nombrePermiso: '',
      datosTabla: [],
      fields: [
        {key: "idPerfil", label: "ID", sortable: true},
        {key: "nombrePerfil", label: "Nombre", sortable: true},
        {key: "fechaModificacion", label: "Fecha modificación", sortable: true},
        {key: "nombreUsuarioModificacion", label: "Usuario modificación", sortable: true},
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 1,
      show: false,
      tituloModal: '',
      perfil: {
        idMenu: null,
        nombrePerfil: null,
        registroActivo: null,
        permisos: []
      },
      loaderAcciones: false,
      loader: false,
      permisos: [],
      permisosBase: [],
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null
      },
    }
  },
  validations: {
    perfil: {
      nombrePerfil: {required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.inicializar();
  },
  methods: {
    inicializar() {
      this.obtenerPerfiles();
      this.obtenerPermisos();
    },
    obtenerPerfiles() {
      this.loader = true;
      this.$http.post(this.$api + 'catalogos/perfil/listaPerfiles', this.filtro).then(respuesta => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;
            }

          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    obtenerPermisos() {
      this.$http.get(this.$api + "catalogos/listaPermisos").then(response => {
            if (response.data.data) {
              this.permisosBase = _.orderBy(response.data.data, ['permiso'], ['asc'])
              this.initPermisosEdit();
            }
          }
      )
    },
    agregar() {
      this.nuevo = true;
      this.perfil = {
        idMenu: null,
        nombrePerfil: null,
        registroActivo: null,
        permisos: []
      };
      this.tituloModal = 'Agregar perfil';
      this.show = true;
    },
    guardar() {
      this.$v.perfil.$touch();
      if (this.$v.perfil.$anyError) {
        return;
      }      

      if (!this.$v.perfil.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'catalogos/perfil/guardar', this.perfil).then(respuesta => {
              if (respuesta.data.data) {
                this.obtenerPerfiles();
                this.show = false;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El perfil se guardó correctamente",
                });
              }
            }
        ).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },
    modificar(item) {
      this.nuevo = false;
      this.perfil = JSON.parse(JSON.stringify(item));
      this.tituloModal = 'Modificar perfil';
      this.initPermisosEdit();
      this.show = true;
    },

    eliminar(item) {
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar el perfil?' : '¿Está seguro de activar el perfil?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros= {
            idPerfil: item.idPerfil
          }
          this.$http.post(this.$api + 'catalogos/perfil/eliminar', parametros).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El perfil se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.perfil[name];
      return $dirty ? !$error : null;
    },
    cerrarModal() {
      this.show = false;
    },
    initPermisosEdit() {
      this.permisos = JSON.parse(JSON.stringify(this.permisosBase));
      this.permisos.forEach(it => {
        it.disabled=false;
        it.activo=this.perfil.permisos.some(idp => idp === it.idPermiso);
        it.idPerfil=this.perfil.idPerfil;
      });
    },
    activarDesactivarPermiso(perm) {
      const estatusActual = perm.activo;
      perm.activo = !perm.activo;
      perm.disabled = true;
      this.$forceUpdate();
      this.$http.post(this.$api + 'catalogos/perfil/guardarPerfilPermiso', perm).then(respuesta => {

        this.$bvToast.toast(respuesta.data.message, {
          title: 'Atajo 1',
          noAutoHide: false,
          autoHideDelay: 3000,
          variant: 'primary',
          solid: true
        })

      }).catch(error => {
        console.error(error.data);
        this.$bvToast.toast("Ocurrio un error al realizar la asignación", {
          title: 'Atajo 1',
          noAutoHide: false,
          autoHideDelay: 3000,
          variant: 'primary',
          solid: true
        })

        perm.activo = estatusActual;
      }).finally(() => {
        perm.disabled = false;
        this.$forceUpdate();
      });
    }
  },
  computed: {

  },
  watch: {
    show() {
      if (!this.show)  {
        this.inicializar();
      }
    }
  }
}
</script>

<style>
.custom-switch {
  width: 250px !important;
  text-align: center;

}
</style>
